import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from 'components';
import { Forms, Results } from './components';
import { Card, Col, Row, Button, Modal, Badge } from 'react-bootstrap';
import { FaCheckCircle, FaClock } from 'react-icons/fa';
import Header from '../../components/Header/Header';
import {
  buildSguTrialPayloadValue,
  formatApiStatusMessage,
  formatSguTrialDateForDisplay,
  formatSguTrialDateForInput,
  getSguTrialStatusMeta,
  hasSguCompanyLink,
  isSguTrialMode,
  normalizeSguTrialFromApi,
} from './components/Forms/sguAccessUtils';
import Reload from '../../components/Reload/Reload';
import ApiGSenha from 'services/ApiGSenha';
import ApiMServer from 'services/ApiMServer';
import {
  normalizePermissionAssist,
  normalizePermissionWebAssistencia,
  normalizeAssistenciaId,
} from './components/Forms/permissionsConfig';
import NotifyModal from '../../components/NotifyModal/NotifyModal';
import { formatCpfOrCnpj } from 'utils/cpfCnpj';

const buildUserSnapshot = (userData) => {
  if (!userData) return '';

  const accessType = userData.accessType || '';
  const managerId = userData.managerId || '';
  const allowedUnitIds = Array.isArray(userData.allowedUnitIds) ? userData.allowedUnitIds : [];
  const isSingleManagerType = accessType === 'cooperative_manager' || accessType === 'unit_manager';
  const isMultiUnitManagerType = accessType === 'multi_unit_manager';
  const linkedToCompany = hasSguCompanyLink(accessType, managerId, allowedUnitIds);
  const isTrialMode = isSguTrialMode(userData.sguTrial);

  let sguTrialSnapshot = null;
  if (linkedToCompany && isTrialMode) {
    sguTrialSnapshot = formatSguTrialDateForInput(userData.sguTrial) || null;
  }

  return JSON.stringify({
    name: userData.name || '',
    email: userData.email || '',
    cpfcnpj: userData.cpfcnpj || '',
    company: userData.company || '',
    fone: userData.fone || '',
    monthlyReportEmail: Boolean(userData.monthlyReportEmail),
    accessType,
    managerId: isSingleManagerType ? managerId : '',
    allowedUnitIds: isMultiUnitManagerType ? [...allowedUnitIds].sort() : [],
    sguTrial: sguTrialSnapshot,
    master: Boolean(userData.master),
    permission: userData.permission,
    permissionAssist: normalizePermissionAssist(userData.permissionAssist),
    permissionWebAssistencia: normalizePermissionWebAssistencia(userData.permissionWebAssistencia),
    permissionSGU: userData.permissionSGU,
    assistenciaId: normalizeAssistenciaId(userData.assistenciaId),
  });
};

const UsersDetail = (props) => {

  const history = useHistory();

  const [valueForm, setValueForm] = useState(false)
  const [valueFormSenhas, setValueFormSenhas] = useState(false)
  const data = JSON.parse(localStorage.getItem('userData'));

  if (data?.permission?.users?.read !== true) {
    window.location.replace('/home');
  }

  const userId = data._id;
  const { permission } = data;

  const [user, setUser] = useState({
    _id: '',
    name: '',
    username: '',
    email: '',
    birth: '',
    equipments: [],
    allowedUnitIds: [],
    accessType: '',
    managerId: '',
    assistenciaId: '',
    password: '',
    master: '',
    permissionAssist: {
      home: {
        read: '',
        write: '',
      },
      equipmentsreplace: {
        read: '',
        write: '',
      },
    },
    permissionWebAssistencia: {
      adm: '',
      painelAssistencias: {
        read: '',
        write: '',
      },
      certificados: {
        read: '',
        write: '',
      },
      senhas: {
        read: '',
        write: '',
      },
      cadastros: {
        read: '',
        write: '',
      },
    },
    permissionSGU: {
      home: {
        read: '',
        write: '',
      },
      equipments: {
        read: '',
        write: '',
      },
      units: {
        read: '',
        write: '',
      },
      restricted: {
        read: '',
        write: '',
      },
      report: {
        read: '',
        write: '',
      },
      settings: {
        read: '',
        write: '',
      },
      silosbag: {
        read: '',
        write: '',
      },
      dryer: {
        read: '',
        write: '',
      },
      sementeira: {
        read: '',
        write: '',
      },
      rodizio: {
        read: '',
        write: '',
      },
      companyData: {
        read: '',
        write: ''
      },
    },

    permission: {
      home: {
        read: '',
        write: ''
      },
      executivePanel: {
        read: '',
        write: ''
      },
      analytics: {
        read: '',
        write: ''
      },
      users: {
        read: '',
        write: ''
      },
      units: {
        read: '',
        write: ''
      },
      cooperatives: {
        read: '',
        write: ''
      },
      equipments: {
        read: '',
        write: ''
      },
      nir: {
        read: '',
        write: ''
      },
      maps: {
        read: '',
        write: ''
      },
      mapsunits: {
        read: '',
        write: ''
      },
      charts: {
        read: '',
        write: ''
      },
      updates: {
        read: '',
        write: ''
      },
      models3d: {
        read: '',
        write: ''
      },
      equipmentsreplace: {
        read: '',
        write: ''
      },
      support: {
        read: '',
        write: ''
      },
      supportnir: {
        read: '',
        write: ''
      },
      supportdry: {
        read: '',
        write: ''
      },
      supportOrange: {
        read: '',
        write: ''
      },
      supportiot: {
        read: '',
        write: ''
      },
      equipmentsQL: {
        read: '',
        write: ''
      },
      notifications: {
        read: '',
        write: ''
      },
      userspassword: {
        read: '',
        write: ''
      },
      assistencia: {
        read: '',
        write: ''
      },
      assistencias: {
        read: '',
        write: ''
      },
      general: {
        read: '',
        write: ''
      },
      logs: {
        read: '',
        write: ''
      }
    },
    fone: '',
    company: '',
    cpfcnpj: '',
    validationHash: '',
    createdAt: '',
    updatedAt: '',
    lastLogin: '',
    app: '',
    __v: 0,
    token: '',
    firebaseToken: '',
    validationEmail: Boolean,
    oldName: null,
    blocked: null,
    sguTrial: null,
    monthlyReportEmail: false
  });

  const [open, setOpen] = useState(false);
  const [openAuth, setOpenAuth] = useState(false);
  const [openAuthenticate, setOpenAuthenticate] = useState(false);
  const [openAuthPassword, setOpenAuthPassword] = useState(false);
  const [openBlockUser, setOpenBlockUser] = useState(false);
  const [openUnblockFone, setOpenUnblockFone] = useState(false);
  const [openSaveConfirm, setOpenSaveConfirm] = useState(false);
  const [pendingUserPayload, setPendingUserPayload] = useState(null);
  const [activactions, setActivactions] = useState([]);
  const [pass, setPass] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);
  const [savedSnapshot, setSavedSnapshot] = useState('');
  const [openUnsavedModal, setOpenUnsavedModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const [currentTheme, setCurrentTheme] = useState('dark');
  const allowNavigationRef = useRef(false);
  const historyUnblockRef = useRef(null);

  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentTheme('dark');
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    document.body.classList.add('dark-theme');
  }, []);

  const hasUnsavedChanges = useMemo(() => {
    if (loading || !savedSnapshot) return false;
    return buildUserSnapshot(user) !== savedSnapshot;
  }, [user, savedSnapshot, loading]);

  useEffect(() => {
    if (!hasUnsavedChanges) {
      if (historyUnblockRef.current) {
        historyUnblockRef.current();
        historyUnblockRef.current = null;
      }
      return undefined;
    }

    const unblock = history.block((location, action) => {
      if (allowNavigationRef.current) return undefined;

      setPendingNavigation({ location, action });
      setOpenUnsavedModal(true);
      return false;
    });

    historyUnblockRef.current = unblock;

    return () => {
      unblock();
      historyUnblockRef.current = null;
    };
  }, [hasUnsavedChanges, history]);

  useEffect(() => {
    if (!hasUnsavedChanges) return undefined;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  const closeUnsavedModal = () => {
    setOpenUnsavedModal(false);
    setPendingNavigation(null);
  };

  const confirmLeaveWithoutSaving = () => {
    const navigation = pendingNavigation;
    allowNavigationRef.current = true;
    setOpenUnsavedModal(false);
    setPendingNavigation(null);

    if (historyUnblockRef.current) {
      historyUnblockRef.current();
      historyUnblockRef.current = null;
    }

    if (navigation?.location) {
      const { pathname, search, hash } = navigation.location;
      const targetPath = `${pathname || ''}${search || ''}${hash || ''}`;

      if (navigation.action === 'POP') {
        history.goBack();
      } else {
        history.push(targetPath);
      }
    }

    window.setTimeout(() => {
      allowNavigationRef.current = false;
    }, 0);
  };

  const navigateWithoutUnsavedWarning = (targetPath) => {
    allowNavigationRef.current = true;

    if (historyUnblockRef.current) {
      historyUnblockRef.current();
      historyUnblockRef.current = null;
    }

    history.push(targetPath);

    window.setTimeout(() => {
      allowNavigationRef.current = false;
    }, 0);
  };

  const handleAlertModalSuccess = (msg, fallback = 'Operação realizada com sucesso!') => {
    setType({ color: '#198754', status: formatApiStatusMessage(msg, fallback) })
    setModalShow(true)
  }

  const handleAlertModalError = (msg, fallback = 'Ocorreu um erro.') => {
    setType({ color: 'red', status: formatApiStatusMessage(msg, fallback) })
    setModalShow(true)
  }

  const removeUser = async () => {
    handleClose();
    try {
      await ApiMServer.delete(`/users/${user._id}`);
      navigateWithoutUnsavedWarning('/users');
    } catch (error) {
      handleAlertModalError('Erro ao apagar usuário!');
    }
  };

  const authUser = async () => {
    handleClose();
    try {
      await ApiMServer.post('/validateemailforced', { _id: user._id });
      handleAlertModalSuccess('E-mail Validado!');
    } catch (error) {
      handleAlertModalError('Erro ao validar E-mail!');
    }
  };

  const authenticateUser = async () => {
    handleClose();
    try {
      await ApiMServer.post('/authenticateuser', { id: user._id });
      handleAlertModalSuccess('Usuário autenticado!');
    } catch (error) {
      handleAlertModalError('Erro ao autenticar usuário!');
    }
  };

  const unblockFone = async () => {
    handleClose();
    try {
      await ApiMServer.post('/user/clearexclusiveaccess', { email: user.email })
      handleAlertModalSuccess('Telefone desbloqueado!');
    } catch (error) {
      handleAlertModalError('Erro ao desbloquear!');
    }
  };

  const authUserPassword = async () => {
    handleClose();
    try {
      let resp = await ApiMServer.post('/passwordgeneratepermission', {
        responsible_id: userId,
        user_update_id: user?._id
      });
      handleAlertModalSuccess(resp.data?.status || 'Usuário autorizado!');
    } catch (error) {
      handleAlertModalError(error?.response?.data?.status || 'Erro ao atualizar!');
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOpenAuth(false);
    setOpenAuthPassword(false);
    setOpenAuthenticate(false);
    setOpenAuthPassword(false);
    setOpenBlockUser(false);
    setOpenUnblockFone(false);
    setOpenSaveConfirm(false);
  };

  const getActivations = async (email) => {
    try {
      let { data } = await ApiGSenha.post('/log/unlockbyuser', { username: email });
      setActivactions(data);
    } catch (error) {
      console.log(error);
      alert('Erro:', error.message);
    }
  };

  const getPass = async (email) => {
    try {
      let { data } = await ApiGSenha.post('/log/passuser', { username: email, params: 50 });
      setPass(data);
    } catch (error) {
      console.log(error);
      alert('Erro:', error.message);
    }
  };

  useEffect(() => {
    (async () => {
      const { id } = props.match.params;

      try {
        let { data } = await ApiMServer.get(`/users/${id}`);

        const defaultPermissionsSGU = {
          home: { read: false, write: false },
          equipments: { read: false, write: false },
          units: { read: false, write: false },
          restricted: { read: false, write: false },
          report: { read: false, write: false },
          settings: { read: false, write: false },
          silosbag: { read: false, write: false },
          dryer: { read: false, write: false },
          sementeira: { read: false, write: false },
          rodizio: { read: false, write: false },
          companyData: { read: false, write: false }
        };

        const defaultPermissions = {
          home: { read: false, write: false },
          executivePanel: { read: false, write: false },
          analytics: { read: false, write: false },
          users: { read: false, write: false },
          units: { read: false, write: false },
          cooperatives: { read: false, write: false },
          equipments: { read: false, write: false },
          nir: { read: false, write: false },
          maps: { read: false, write: false },
          mapsunits: { read: false, write: false },
          charts: { read: false, write: false },
          updates: { read: false, write: false },
          models3d: { read: false, write: false },
          equipmentsreplace: { read: false, write: false },
          equipmentsQL: { read: false, write: false },
          notifications: { read: false, write: false },
          userspassword: { read: false, write: false },
          assistencia: { read: false, write: false },
          assistencias: { read: false, write: false },
          general: { read: false, write: false },
          support: { read: false, write: false },
          supportnir: { read: false, write: false },
          supportdry: { read: false, write: false },
          supportOrange: { read: false, write: false },
          supportiot: { read: false, write: false },
          logs: { read: false, write: false },
        };

        // Adiciona as permissões caso não existam
        data.permissionAssist = normalizePermissionAssist(data.permissionAssist);
        const rawAssistenciaId =
          data.assistenciaId || data.permissionWebAssistencia?.assistencia;
        data.permissionWebAssistencia = normalizePermissionWebAssistencia(
          data.permissionWebAssistencia
        );
        data.assistenciaId = normalizeAssistenciaId(rawAssistenciaId);
        data.permissionSGU = { ...defaultPermissionsSGU, ...data.permissionSGU };
        data.permission = { ...defaultPermissions, ...data.permission };

        // Migra permissão legada remoteaccess -> supportOrange
        if (
          data.permission?.remoteaccess &&
          !data.permission?.supportOrange?.read &&
          !data.permission?.supportOrange?.write
        ) {
          data.permission.supportOrange = {
            read: data.permission.remoteaccess.read === true,
            write: data.permission.remoteaccess.write === true,
          };
        }

        const loadedUser = {
          ...data,
          accessType: data.accessType || '',
          managerId: data.managerId || '',
          assistenciaId: data.assistenciaId || '',
          allowedUnitIds: Array.isArray(data.allowedUnitIds) ? data.allowedUnitIds : [],
          sguTrial: normalizeSguTrialFromApi(data.sguTrial)
        };

        setUser(loadedUser);
        setSavedSnapshot(buildUserSnapshot(loadedUser));
        await Promise.all([getActivations(data.email), getPass(data.email)]);
      } catch (error) {
        console.error("Erro ao carregar usuário:", error);
        alert(error.message);
      }

      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await ApiMServer.get('/company/get');
        setCompanies(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Erro ao carregar empresas:', error);
      }
    })();
  }, []);


  const fieldChanged = (event, field, value) => {
    event.persist && event.persist();
    setUser((values) => ({
      ...values,
      [field]: value
    }))
  }

  const cpfChanged = (event, field, value) => {
    event.persist && event.persist();
    setUser((values) => ({
      ...values,
      [field]: formatCpfOrCnpj(value)
    }));
  };

  const phoneMask = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1)$2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  };

  const phoneChanged = (event, field, value) => {
    event.persist && event.persist();
    setUser((values) => ({
      ...values,
      [field]: phoneMask(value)
    }));
  };

  const saveUser = async () => {
    try {
      const accessType = user.accessType || '';
      const managerId = user.managerId || '';
      const allowedUnitIds = Array.isArray(user.allowedUnitIds) ? user.allowedUnitIds : [];
      const isSingleManagerType = accessType === 'cooperative_manager' || accessType === 'unit_manager';
      const isMultiUnitManagerType = accessType === 'multi_unit_manager';

      if (isSingleManagerType && !managerId) {
        handleAlertModalError('Selecione uma cooperativa/unidade para vincular ao gestor.');
        return;
      }

      if (isMultiUnitManagerType && allowedUnitIds.length === 0) {
        handleAlertModalError('Selecione ao menos uma unidade para o gestor.');
        return;
      }

      const linkedToCompany = hasSguCompanyLink(accessType, managerId, allowedUnitIds);
      const isTrialMode = isSguTrialMode(user.sguTrial);

      if (linkedToCompany && isTrialMode && !formatSguTrialDateForInput(user.sguTrial)) {
        handleAlertModalError('Selecione a data de validade do trial ou use um dos atalhos (+7, +15, +30 ou +90 dias).');
        return;
      }

      const userPayload = {
        ...user,
        permissionAssist: normalizePermissionAssist(user.permissionAssist),
        permissionWebAssistencia: normalizePermissionWebAssistencia(
          user.permissionWebAssistencia
        ),
        assistenciaId: normalizeAssistenciaId(user.assistenciaId),
        userId,
        accessType,
        managerId: isSingleManagerType ? managerId : '',
        allowedUnitIds: isMultiUnitManagerType ? allowedUnitIds : []
      };

      delete userPayload.sguTrial;

      if (linkedToCompany && isTrialMode) {
        const trialEndDate = buildSguTrialPayloadValue(user.sguTrial);
        if (trialEndDate) {
          userPayload.sguTrial = trialEndDate;
        }
      } else if (linkedToCompany) {
        userPayload.sguTrial = null;
      }

      setPendingUserPayload(userPayload);
      setOpenSaveConfirm(true);
    } catch (error) {
      if (error?.response?.data?.status) {
        handleAlertModalError(error?.response?.data?.status);
      } else {
        handleAlertModalError("Erro ao atualizar, faça login novamente!");
      }
    }
  };

  const confirmSaveUser = async () => {
    if (!pendingUserPayload) return;

    try {
      const { data } = await ApiMServer.put('/api/v1/user-update', pendingUserPayload);
      setOpenSaveConfirm(false);
      setPendingUserPayload(null);
      setUser((current) => {
        const updatedUser = {
          ...current,
          sguTrial: normalizeSguTrialFromApi(data?.sguTrial ?? current.sguTrial),
        };
        setSavedSnapshot(buildUserSnapshot(updatedUser));
        return updatedUser;
      });
      handleAlertModalSuccess(data?.status, 'Atualizado com sucesso!');
    } catch (error) {
      handleAlertModalError(
        error?.response?.data?.status,
        'Erro ao atualizar, faça login novamente!'
      );
    }
  };

  const closeSaveConfirmModal = () => {
    setOpenSaveConfirm(false);
    setPendingUserPayload(null);
  };

  const getAccessTypeLabel = (accessType) => {
    const labels = {
      no_access: 'Sem acesso',
      cooperative_manager: 'Gestor de Cooperativa',
      unit_manager: 'Gestor de Unidade',
      multi_unit_manager: 'Gestor de 2 ou mais Unidades'
    };
    return labels[accessType] || 'Nao definido';
  };

  const companyById = companies.reduce((acc, company) => {
    if (company?._id) {
      acc[company._id] = company;
    }
    return acc;
  }, {});

  const pendingLinkedNames = (Array.isArray(pendingUserPayload?.allowedUnitIds) ? pendingUserPayload.allowedUnitIds : [])
    .map((id) => companyById[id]?.name || id)
    .sort((a, b) => a.localeCompare(b, 'pt-BR'));
  const pendingManagerName = pendingUserPayload?.managerId ? (companyById[pendingUserPayload.managerId]?.name || pendingUserPayload.managerId) : '';
  const pendingSguTrialStatus = pendingUserPayload?.sguTrial
    ? getSguTrialStatusMeta(pendingUserPayload.sguTrial)
    : null;
  const pendingHasSguLink = pendingUserPayload
    ? hasSguCompanyLink(
      pendingUserPayload.accessType,
      pendingUserPayload.managerId,
      pendingUserPayload.allowedUnitIds
    )
    : false;

  const forgotPassword = async () => {
    handleClose();
    try {
      await ApiMServer.post('/forgotpassword', { email: user.email })
      handleAlertModalSuccess('Enviado com sucesso!');
    } catch (error) {
      handleAlertModalError("Erro ao enviar!");
    }
  };

  const handleBlockUser = () => {
    handleClose();
    try {
      ApiMServer.post('/blockuser', { id: user._id, block: !user.blocked });
      setUser((values) => ({
        ...values,
        'blocked': !user.blocked
      }));
      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      handleAlertModalError("Erro ao atualizar!");
    }
  };

  return (
    <Page className="p-3" title="Usuários">

      <Header page={'Usuários'} />

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Modal
        show={openUnsavedModal}
        onHide={closeUnsavedModal}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Alterações não salvas</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Você fez alterações que ainda não foram salvas. Deseja sair sem salvar?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={closeUnsavedModal}>
            Continuar editando
          </Button>
          <Button variant="danger" onClick={confirmLeaveWithoutSaving}>
            Sair sem salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Card className='mb-2 mt-2 p-2'>
        <Row>
          <Col>
            <Button
              className='ms-2 mt-2 mb-2'
              onClick={() => { setOpenAuthenticate(true) }}
              disabled={!permission?.users?.write}
              variant="outline-success"
            >
              Autenticar Usuário
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              onClick={() => { setOpenAuth(true) }}
              disabled={!permission?.users?.write}
              variant="outline-success"
            >
              Validar E-mail
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              onClick={forgotPassword}
              disabled={!permission?.users?.write}
              variant="outline-success"
            >
              Enviar E-mail Recuperação de Senha
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              onClick={() => setOpenAuthPassword(true)}
              disabled={!permission?.users?.write}
              variant="outline-success"
            >
              Autorizar Gera Senha
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission?.users?.write}
              onClick={() => setOpenUnblockFone(true)}
              variant="outline-success"
            >
              Desbloquear Telefone
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              onClick={() => { setOpenBlockUser(true) }}
              disabled={!permission?.users?.write}
              variant="outline-success"
            >
              {user?.blocked ? 'Desbloquear Usuário' : 'Bloquear Usuário'}
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission?.users?.write}
              onClick={() => setOpen(true)}
              variant="outline-danger"
            >
              Remover
            </Button>
          </Col>
        </Row>
      </Card>

      {loading && <Reload />}

      <Forms
        fieldChanged={fieldChanged}
        cpfChanged={cpfChanged}
        phoneChanged={phoneChanged}
        saveUser={saveUser}
        permission={permission}
        user={user}
        setUser={setUser}
        setValueForm={setValueForm}
        setValueFormSenhas={setValueFormSenhas}
        theme={currentTheme}
        companies={companies}
      />

      {!valueForm ? null :
        <Results title={'Ativações'} data={activactions} />
      }

      {!valueFormSenhas ? null :
        <Results title={'Senhas Geradas'} data={pass} />
      }

      {/* Confirmar atualização de usuário */}
      <Modal
        show={openSaveConfirm}
        onHide={closeSaveConfirmModal}
        size="lg"
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Confirmar novas configurações</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          <div className={`p-3 rounded border mb-3 ${currentTheme === 'dark' ? 'border-secondary bg-dark' : 'border-success bg-light'}`}>
            <h6 className="mb-3">Dados principais</h6>
            <p className="mb-2"><strong>Nome:</strong> {pendingUserPayload?.name || '-'}</p>
            <p className="mb-2"><strong>E-mail:</strong> {pendingUserPayload?.email || '-'}</p>
            <p className="mb-2"><strong>Telefone:</strong> {pendingUserPayload?.fone || '-'}</p>
            <p className="mb-0"><strong>Empresa:</strong> {pendingUserPayload?.company || '-'}</p>
          </div>

          <div className={`p-3 rounded border ${currentTheme === 'dark' ? 'border-secondary bg-dark' : 'border-success bg-light'}`}>
            <h6 className="mb-3">Acesso de gestão</h6>
            <p className="mb-2"><strong>Tipo de gestor:</strong> {getAccessTypeLabel(pendingUserPayload?.accessType)}</p>

            {pendingManagerName ? (
              <p className="mb-2"><strong>Vínculo único:</strong> {pendingManagerName}</p>
            ) : null}

            {pendingLinkedNames.length > 0 ? (
              <div className="mb-2">
                <strong>Unidades vinculadas:</strong>
                <ul className="mt-2 mb-0">
                  {pendingLinkedNames.map((unitName) => (
                    <li key={unitName}>{unitName}</li>
                  ))}
                </ul>
              </div>
            ) : null}

            {!pendingManagerName && pendingLinkedNames.length === 0 ? (
              <small className={currentTheme === 'dark' ? 'text-light' : 'text-muted'}>
                Nenhum vínculo de gestão definido.
              </small>
            ) : null}

            {pendingHasSguLink ? (
              <div className={`mt-3 pt-3 ${currentTheme === 'dark' ? 'border-secondary border-top' : 'border-top'}`}>
                <strong className="d-block mb-2">Acesso SGU</strong>
                {pendingUserPayload?.sguTrial ? (
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <Badge bg="warning" text="dark">
                      <FaClock className="me-1" aria-hidden />
                      Trial
                    </Badge>
                    <span>
                      Válido até <strong>{formatSguTrialDateForDisplay(pendingUserPayload.sguTrial)}</strong>
                    </span>
                    {pendingSguTrialStatus ? (
                      <Badge bg={pendingSguTrialStatus.variant}>{pendingSguTrialStatus.label}</Badge>
                    ) : null}
                  </div>
                ) : (
                  <Badge bg="success">
                    <FaCheckCircle className="me-1" aria-hidden />
                    Assinante — acesso sem prazo
                  </Badge>
                )}
              </div>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={closeSaveConfirmModal}>
            Cancelar
          </Button>
          <Button variant="success" onClick={confirmSaveUser}>
            Confirmar e Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Desbloquer telefone */}
      <Modal
        show={openUnblockFone}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Desbloquear</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Confirma Desbloquear Telefone?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="danger" onClick={unblockFone}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Remover Usuário */}
      <Modal
        show={open}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Remover</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Confirma Remover este Usuário?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="danger" onClick={removeUser}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Autorizar Usuário */}
      <Modal
        show={openAuth}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Autorizar</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Autorizar E-mail desse Usuário?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="success" onClick={authUser}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Autenticar Cadastro */}
      <Modal
        show={openAuthenticate}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Autenticar Cadastro</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Validar o Cadastro Deste Usuário?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="success" onClick={authenticateUser}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Autorizar Gerar Senha */}
      <Modal
        show={openAuthPassword}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>Autorizar Gerar Senha</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Autorizar Usuário a Gerar Senhas para o Equipamento Motomco?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="success" onClick={authUserPassword}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Bloquear/Desbloquear Usuário */}
      <Modal
        show={openBlockUser}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>
            {user?.blocked ? 'Desbloquear Usuário' : 'Bloquear Usuário'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Deseja {user?.blocked ? 'Desbloquear' : 'Bloquear'} este Usuário Para
          Gerar Ativações ao Equipamento Motomco?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant={user?.blocked ? 'success' : 'danger'} onClick={handleBlockUser}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

    </Page>
  );
};

export default UsersDetail;
